import React from "react";
import iconA from "../assets/pad-pro-services-sectionC.png";

export default function ServicesSectionC() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-24 bg-gray-100" data-aos="fade-right" data-aos-duration="1000">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-6 sm:gap-8 lg:gap-12 xl:gap-16">
          
          {/* Text Content - Enhanced responsive design */}
          <div className="w-full lg:w-2/3 order-2 lg:order-1">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl text-black mb-4 sm:mb-6 lg:mb-8 newsreader leading-tight text-center lg:text-left">
              Creating a Safe and Supportive Environment for Adults to Thrive
            </h2>
            
            <div className="space-y-4 sm:space-y-5 lg:space-y-6 text-black leading-relaxed">
              <p className="text-sm sm:text-base lg:text-lg xl:text-md text-center lg:text-left">
                Discover the latest initiatives, accomplishments, and developments at Piedmont Adult Day Program. Our mission is to provide a structured, inclusive, and engaging environment tailored to the unique needs and choices of adults in today's world.
              </p>
              
              <p className="text-sm sm:text-base lg:text-lg xl:text-md text-center lg:text-left">
                Our ultimate goal is to empower individuals through skill-building, effective communication, and informed decision-making, fostering independence and personal growth.
              </p>
            </div>
            
          </div>

          {/* Image - Enhanced responsive design */}
          <div className="w-full lg:w-1/3 order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative max-w-sm sm:max-w-md lg:max-w-full w-full">
              <div className="relative group">
                <img
                  src={iconA}
                  alt="Safe and supportive learning environment with adults engaged in educational activities"
                  className="w-full h-auto rounded-lg shadow-lg group-hover:shadow-2xl transition-all duration-500 transform group-hover:scale-105"
                />
                
                {/* Enhanced overlay effects */}
                <div className="absolute inset-0 rounded-lg border-2 border-transparent group-hover:border-green-300 transition-all duration-300"></div>
                
                {/* Subtle gradient overlay for visual appeal */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
              </div>

              {/* Image caption - Added for context */}
              <div className="mt-3 sm:mt-4 text-center lg:text-left">
                <p className="text-xs sm:text-sm text-gray-600 italic">
                  Adults engaged in structured learning activities
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}